import React from "react";
import { BENEFITS } from "../data/site";

const BenefitStrip = () => {
  return (
    <section className="container-x py-16 md:py-24" data-testid="benefit-strip">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
        {BENEFITS.map((b, i) => (
          <div
            key={b.title}
            className="bg-chalk p-8 lg:p-10 group hover:bg-white transition-colors"
            data-testid={`benefit-${i}`}
          >
            <p className="mono text-xs text-mute mb-6">0{i + 1}</p>
            <h3 className="font-display text-xl md:text-2xl uppercase tracking-tight leading-tight">
              {b.title}
            </h3>
            <p className="mt-3 text-sm text-mute leading-relaxed">{b.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitStrip;
